import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shifts',
  templateUrl: './shifts.component.html',
  styleUrls: ['./shifts.component.css']
})
export class ShiftsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
